define(['jquery',
        'selectize'],
    function($) {
        var safeInstance = function($node) {
            if (!$node instanceof $) {
                $node = $($node);
            }

            if ($node.length < 1) {
                throw Error('Cannot find node for Selectize instance: ' + $node);
            }
            if (!$node[0].hasOwnProperty('selectize')) {
                throw Error('Cannot find Selectize instance in given node: ' + $node);
            }
            return $node[0].selectize;
        };

        var defaultPlugins = function($select) {
            var plugins = [];
            if ($select.attr('multiple')) {
                plugins.push('remove_button');
            }
            return plugins;
        };

        function autoInitializeSelects() {
            $('select:not(.selectize-manually)').each(function () {
                var $this = $(this),
                    enableCreate = $this.data('tags') === true,
                    options = {
                        plugins: defaultPlugins($this),
                        create: enableCreate,
                        createOnBlur: enableCreate
                    };
                if ($this.data('sortBy')) {
                    var order = $this.data('sortOrder') || 'asc';
                    options.sortField = [
                        {
                            field: $this.data('sortBy'),
                            direction: order
                        },
                        {
                            field: '$score'
                        }
                    ]
                }
                $this.selectize(options);
            });
        }

        autoInitializeSelects();

        return {
            safeInstance: safeInstance,
            optionalInstance: function($node) {
                try {
                    return this.safeInstance($node);
                } catch (e) {
                    // silently ignore the error and return undefined
                }
            },
            plugins: function($node, additionalPluginNames) {
                var result = defaultPlugins($node);

                if (additionalPluginNames && additionalPluginNames.length) {
                    additionalPluginNames.split(' ').forEach(function(plugin) {
                        result.push(plugin);
                    })
                }
                return result;
            },
            pluginsAsObject: function($node, additionalPluginNames) {
                var result = {};

                this.plugins($node, additionalPluginNames).forEach(function(plugin) {
                    result[plugin] = {};
                });

                return result;
            },
            createItems: function(selectize, items) {
                var wasCreateEnabled = selectize.settings.create;

                selectize.settings.create = true;
                items.forEach(function(item) {
                    selectize.createItem(item);
                });
                selectize.settings.create = wasCreateEnabled;
            },
            autoInitializeSelects: autoInitializeSelects
        }
    }
);
